module.exports = __webpack_public_path__ + "img/mission_money_w.0c82d9f.svg";